import React, { memo } from "react";
import Separator from "../../../../../core/components/Separator.tsx";
import IconButton from "../../../../../core/components/IconButton.tsx";
import { motion } from "framer-motion";
import "./data-entry-viagens.css";
import "./text-field.css";

interface TextFieldProps {
	label?: string;
	placeholder?: string;
	value: string;
	onChange: (value: string) => void;
	onSubmit?: () => void;
	error?: string;
}

function TextField({
	label,
	placeholder = "Digite e pressione Enter",
	value,
	onChange,
	onSubmit,
	error,
}: TextFieldProps) {
	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			e.preventDefault();
			onSubmit && onSubmit();
		}
	};

	const handleButtonClick = () => {
		onSubmit && onSubmit();
	};

	return (
		<div className="text-field-container">
			{label && <label className="text-field-label">{label}</label>}
			<Separator size="2xs" />
			<div className="modal-filtros-viagens-input-tag">
				<motion.div
					transition={{ duration: 0.2, delay: 0.1 }}
					style={{
						border: "1px solid #fff",
						boxShadow: "none",
					}}
					className="modal-filtros-viagens-input-button"
				>
					<input
						type="text"
						className="select-field-input"
						value={value}
						onChange={(e) => onChange(e.target.value)}
						onKeyDown={handleKeyDown}
						placeholder={placeholder}
					/>
					<Separator size="xs" direction="horizontal" />
				</motion.div>
			</div>
			{error && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.2 }}
				>
					<Separator size="xs" />
					<div
						className="text-field-error"
						style={{ color: "red", fontSize: "0.8rem" }}
					>
						{error}
					</div>
				</motion.div>
			)}
		</div>
	);
}

export default memo(TextField);
